import { ReclamationQualificationDetailCodes } from 'constants.js';
import { ReclamationQualificationDetailType } from 'constants.js';


const adrToString = (nom, adresse1, adresse2, codePostal, ville ) => {

    let adresseStr = nom;
        if (adresse1 && adresse1 !== '') {
            adresseStr += '\r\n' + adresse1;
        }
        if (adresse2 && adresse2 !== '') {
            adresseStr += '\r\n' + adresse2;
        }
        adresseStr += '\r\n' + codePostal + ' ' + ville;

        return adresseStr;
    }


export default {
    isValid: (enlevement) => {

        //console.log('isValid', enlevement);

        if (!enlevement) {
            return { valid: false, errorMsg: "Il manque tout" };
        }

        if (!enlevement.adresseEnlevementNomLivraison) {
            return { valid: false, errorMsg: "Il manque le champ nom sur l'adresse d'enlèvement" };
        }

        if (!enlevement.adresseEnlevementAdresse1) {
            return { valid: false, errorMsg: "Il manque le champ adresse1 sur l'adresse d'enlèvement" };
        }

        if (!enlevement.adresseEnlevementCodePostal) {
            return { valid: false, errorMsg: "Il manque le champ code postal sur l'adresse d'enlèvement" };
        }

        if (!enlevement.adresseEnlevementVille) {
            return { valid: false, errorMsg: "Il manque le champ ville sur l'adresse d'enlèvement" };
        }


        if (!enlevement.contactClientNom) {
            return { valid: false, errorMsg: "Il manque le champ nom sur le contact client" };
        }
        if (!enlevement.contactClientEmail) {
            return { valid: false, errorMsg: "Il manque le champ mail sur le contact client" };
        }
        if (!enlevement.contactClientTelephone) {
            return { valid: false, errorMsg: "Il manque le champ téléphone sur le contact client" };
        }



        if (!enlevement.adresseDestinationNom) {
            return { valid: false, errorMsg: "Il manque le champ nom sur l'adresse de destination" };
        }

        if (!enlevement.adresseDestinationAdresse1) {
            return { valid: false, errorMsg: "Il manque le champ adresse1 sur l'adresse de destination" };
        }

        if (!enlevement.adresseDestinationCodePostal) {
            return { valid: false, errorMsg: "Il manque le champ code postal sur l'adresse de destination" };
        }

        if (!enlevement.adresseDestinationVille) {
            return { valid: false, errorMsg: "Il manque le champ ville sur l'adresse de destination" };
        }


        if (!enlevement.poidsTheorique) {
            return { valid: false, errorMsg: "Veuillez spécifier le poids théorique de l'enlèvement." };
        }



        if (enlevement.nbColis === 0
            && enlevement.nbLongueurs === 0
            && enlevement.nbPalettes === 0) {

            return { valid: false, errorMsg: "Veuillez spécifier le colisage." };
            
        }


        return { valid: true, errorMsg: null };
    },



    toQualificationDetails: (enlevement) => {

        let qualificationDetails = [];

        console.log('toQualificationDetails', enlevement);

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.AdresseEnlevement,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Adresse d'enlèvement",
                valeurString: adrToString(enlevement.adresseEnlevementNomLivraison, enlevement.adresseEnlevementAdresse1, enlevement.adresseEnlevementAdresse2, enlevement.adresseEnlevementCodePostal, enlevement.adresseEnlevementVille)
            });


        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.ContactClientNom,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Contact, nom",
                valeurString: enlevement.contactClientNom
            });
        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.ContactClientEmail,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Contact, email",
                valeurString: enlevement.contactClientEmail
            });
        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.ContactClientTelephone,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Contact, téléphone",
                valeurString: enlevement.contactClientTelephone
            });

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.AdresseDestination,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Adresse de destination",
                valeurString: adrToString(enlevement.adresseDestinationNom, enlevement.adresseDestinationAdresse1, enlevement.adresseDestinationAdresse2, enlevement.adresseDestinationCodePostal, enlevement.adresseDestinationVille)
            });

        if (enlevement.dateSouhaitee !== null) {
            qualificationDetails.push(
                {
                    code: ReclamationQualificationDetailCodes.DateEnlevement,
                    type: ReclamationQualificationDetailType.Date,
                    libelle: "Date d'enlèvement souhaitée",
                    valeurDate: enlevement.dateSouhaitee.toDateString()
                });
        }

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.Poids,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Poids théorique",
                valeurInteger: enlevement.poidsTheorique
            });

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.NombrePalettes,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Nombre de palettes",
                valeurInteger: enlevement.nbPalettes
            });

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.NombreColis,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Nombre de colis",
                valeurInteger: enlevement.nbColis
            });

        qualificationDetails.push(
            {
                code: ReclamationQualificationDetailCodes.NombreLongueurs,
                type: ReclamationQualificationDetailType.Nombre,
                libelle: "Nombre de longueurs",
                valeurInteger: enlevement.nbLongueurs
            });




        console.log('toQualificationDetails qualificationDetails', qualificationDetails);


        return qualificationDetails;
    }    
}
